
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/latest/[brand]/[model]",
      function () {
        return require("private-next-pages/latest/[brand]/[model]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/latest/[brand]/[model]"])
      });
    }
  